import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-registro',
  templateUrl: './registro.component.html',
  styleUrls: ['./registro.component.scss']
})
export class RegistroComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
